<script setup lang="ts">
import type { SocialMedia } from "@/schemas/social-media";

defineProps<{ items: SocialMedia[] }>();
const icons: Record<string, string> = {
  facebook: "i-cib-facebook",
  instagram: "i-cib-instagram",
  tiktok: "i-cib-tiktok",
};
</script>

<template>
  <ul class="inline-flex items-center gap-2">
    <template v-for="(item, i) in items" :key="i">
      <li v-if="icons[item.icon]">
        <a :href="item.url" target="_blank" rel="noopener noreferrer" class="flex">
          <span class="size-6" :class="icons[item.icon]" />
        </a>
      </li>
    </template>
  </ul>
</template>
